export const getMaxValueInDataSet = (dataSet, numOfIntervals) => {
  let maxValue = -1;
  dataSet.forEach((num) => {
    if (num > maxValue) {
      maxValue = num;
    }
  });
  return Math.ceil(maxValue / numOfIntervals) * numOfIntervals;
};

export const getHumanFriendlyGraphIntervals = (maxValue, numOfIntervals) => {
  const edgeCaseArray = Array(numOfIntervals); // Create an array with x elements
  for (let i = 0; i < numOfIntervals; i++) {
    edgeCaseArray[i] = i; // Assign values from 0 to x-1
  }

  if (maxValue <= 0) return edgeCaseArray; // Edge case

  // Determine the rounding factor
  let roundingFactor = Math.pow(10, Math.floor(Math.log10(maxValue)));

  // Round up to the nearest multiple of roundingFactor
  let roundedMax = Math.ceil(maxValue / roundingFactor) * roundingFactor;

  // Compute the step size
  let step = roundedMax / numOfIntervals;

  // Generate intervals
  let intervals = [];
  for (let i = 0; i <= numOfIntervals; i++) {
    intervals.push(i * step);
  }

  return intervals;
};
